import React, { useState, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import DataTable from "react-data-table-component";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { toastify } from "../../../helperFunctions/toastify";
import DateInput from "../../SharedComponents/DateInput";
import { setTableSearch } from "../../../redux/slices/commonSlice";
import { getReceivingListingReport } from "../../../apis/customTemplate";

import {
    downloadCsv,
    formatDate,
} from "../../../helperFunctions/utils";
const FilterWrapper = styled.div`
  label {
    color: inherit;
  }

  .btn-wrapper {
    align-items: center;
    display: flex;
    margin-top: 20px;
  }
`;

function ReceivingListingReport() {
    const dispatch = useDispatch();
    const location = useLocation();
    const buttonRef = useRef(null);
    const pathname = location.pathname;
    const fieldPathname = pathname.replace("/", "");
    const [refetch, setRefetch] = useState(false);

    const { tableSearch } = useSelector((state) => state.commonData);
    const [startDate, setStartDate] = useState(tableSearch[fieldPathname]?.receivingListingReport?.startDate ? tableSearch[fieldPathname]?.receivingListingReport?.startDate : new Date());
    const [endDate, setEndDate] = useState(tableSearch[fieldPathname]?.receivingListingReport?.endDate ? tableSearch[fieldPathname]?.receivingListingReport?.endDate : new Date());

    const [filteredData, setFilteredData] = useState([]);
    const [refundList, setRefundList] = useState([]);

    const onReduxFilter = (valueStartDate, valueEndDate) => {
        dispatch(
            setTableSearch({
                ...tableSearch,
                [fieldPathname]: {
                    ...tableSearch[fieldPathname],
                    receivingListingReport: {
                        startDate: valueStartDate,
                        endDate: valueEndDate,
                    },
                },
            })
        );
    };

    // useEffect(() => {
    //   (async () => {
    //     const response = await getPatients();
    //     if (response?.status !== "Fail") {
    //       setPatients(response);
    //     } else {
    //       toastify("Failed to get patients", "error");
    //     }
    //   })();
    // }, []);

    useEffect(() => {
        setStartDate(tableSearch[fieldPathname]?.receivingListingReport?.startDate ? tableSearch[fieldPathname]?.receivingListingReport?.startDate : new Date());
        setEndDate(tableSearch[fieldPathname]?.receivingListingReport?.endDate ? tableSearch[fieldPathname]?.receivingListingReport?.endDate : new Date());

        if (
            buttonRef.current &&
            (tableSearch[fieldPathname]?.receivingListingReport?.startDate &&
                tableSearch[fieldPathname]?.receivingListingReport?.endDate
            )) {
            setTimeout(() => {
                if (buttonRef.current) {
                    buttonRef.current.click();
                }
            }, [1000]);
        }
    }, []);

    useEffect(() => {
        getReceivingListingReport({
            startDate: startDate,
            endDate: endDate,
        }).then((res) => {
            console.log("res?.result?.data", res?.result?.data);
            if (res?.result?.data) {
                setRefundList(res.result.data);
                setFilteredData(res.result.data);
            }
        });
    }, [refetch]);

    // eslint-disable-next-line no-sparse-arrays
    const columns = [
        {
            name: "Purchase Doc No",
            selector: (row) => row.purchaseDocNo,
            cell: (row) => row.purchaseDocNo,
        },
        {
            name: "Received Doc No",
            selector: (row) => row.receivedDocNo,
            cell: (row) => row.receivedDocNo,
        },
        {
            name: "Received Date",
            selector: (row) => row.receivedDate,
            cell: (row) => formatDate(row.receivedDate),
        },
        {
            name: "Products",
            selector: (row) => "",
            cell: (row) => {
                if (row.products?.length === 0) {
                    return "-";
                }

                return (
                    <div>
                        {
                            row.products.map((rowProduct, rowIdx) => {
                                return (
                                    <div key={rowIdx} style={{ display: "block" }}>{rowProduct.productName} - {`Received Qty : ${rowProduct.recivedQty}`}</div>
                                );
                            })
                        }
                    </div>
                )
            },
        }
    ];

    const data = filteredData?.map((e, index) => {
        return {
            ...e,
            index,
            key: index,
        };
    });

    const customStyles = {
        headCells: {
            style: {
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                justifyContent: "center",
            },
        },
    };

    const conditionalRowStyles = [
        {
            when: (row) => row,
            style: {
                borderWidth: "0px",
            },
        },
        {
            when: (row) => row.index % 2 === 1,
            style: {
                backgroundColor: "#f8f8f8",
                borderWidth: "0px",
            },
        },
    ];

    const exportCsv = () => {
        const csvData = refundList.map((row) => {
            let stock_products = "";
            row.products.map((rowp) => {
                stock_products += `${rowp.productName} - Received Qty : ${rowp.recivedQty}, `;
            })

            return {
                "Purchase Doc No": row.purchaseDocNo,
                "Received Doc No": row.receivedDocNo,
                "Received Date": formatDate(row.receivedDate),
                "Products": stock_products
            }
        });


        downloadCsv(csvData, "Receiving_Stock_Listing_Report");
    };

    return (
        <div className="p-0">
            <div
                className="mainHeading"
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <FilterWrapper className="d-flex">
                        <div className="me-3" style={{ width: "260px" }}>
                            <DateInput
                                value={startDate}
                                label="Start Date"
                                placeholder="Select"
                                onChange={(e) => {
                                    setStartDate(e);
                                }}
                            />
                        </div>
                        <div className="me-3" style={{ width: "260px" }}>
                            <DateInput
                                value={endDate}
                                label="End Date"
                                placeholder="Select"
                                onChange={(e) => {
                                    setEndDate(e);
                                }}
                            />
                        </div>
                        <div className="btn-wrapper">
                            <Button
                                ref={buttonRef}
                                className="addItem me-3"
                                onClick={() => {
                                    if (endDate < startDate) {
                                        toastify("End date is less than start date", "error");
                                        return;
                                    }
                                    onReduxFilter(startDate, endDate);
                                    setRefetch(!refetch);
                                }}
                            >
                                Search
                            </Button>
                            <Button className="addItem" onClick={() => exportCsv()}>
                                Export
                            </Button>
                        </div>
                    </FilterWrapper>
                </div>
            </div>

            <DataTable
                columns={columns}
                data={data || []}
                pagination
                customStyles={customStyles}
                conditionalRowStyles={conditionalRowStyles}
            />
        </div>
    );
}

export default ReceivingListingReport;
